export const TEMPLATE_VARIABLES = [
  { key: 'lead_name', label: 'Lead Name', description: 'Full name of the lead' },
  { key: 'first_name', label: 'First Name', description: 'First name only' },
  { key: 'city', label: 'City', description: "Lead's city" },
  { key: 'phone', label: 'Phone', description: "Lead's phone number" },
  { key: 'quote_url', label: 'Quote URL', description: 'Link to the estimate/quote' },
  { key: 'book_a_call_url', label: 'Book a Call URL', description: 'Personalized link to schedule a call (pre-fills their info)' },
  { key: 'estimate_total', label: 'Estimate Total', description: 'Total price of the estimate' },
  { key: 'company_name', label: 'Company Name', description: 'Mr. Patch Asphalt' },
];

export const SAMPLE_LEAD = {
  name: 'John Smith',
  phone: '(555) 123-4567',
  city: 'Tampa',
  book_a_call_url: 'https://mrpatchasphalt.com/book-a-call.html?t=r6jnY6',
};

export const SAMPLE_ESTIMATE = {
  publicToken: 'abc123',
  totalPrice: '2,500.00',
};

export const replaceTemplateVariables = (body, lead, estimate = null) => {
  if (!body || !lead) return body || '';

  const mostRecentEstimate = estimate || null;
  const publicToken = mostRecentEstimate?.publicToken;
  const quoteUrl = publicToken
    ? `https://crm.mrpatchasphalt.com/quote/${publicToken}`
    : '';

  const totalPrice = mostRecentEstimate?.totalPrice
    ? Number(mostRecentEstimate.totalPrice).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })
    : '';

  const variables = {
    lead_name: lead.name || '',
    first_name: (lead.name || '').split(' ')[0],
    city: lead.city || '',
    phone: lead.phone || '',
    quote_url: quoteUrl,
    book_a_call_url: lead.book_a_call_url || '',
    estimate_total: totalPrice,
    company_name: 'Mr. Patch Asphalt',
  };

  return body.replace(/\{(\w+)\}/g, (match, key) => {
    return key in variables ? variables[key] : match;
  });
};

export const replaceWithSampleData = (body) => {
  return replaceTemplateVariables(body, SAMPLE_LEAD, SAMPLE_ESTIMATE);
};
